/* ============================================================
 * QUIZ TRACKER · Terramoda
 *
 * Cliente de tracking unificado. Despacha cada evento a:
 *  1. Meta Pixel (window.fbq)
 *  2. GA4 (window.gtag)
 *  3. Microsoft Clarity (window.clarity)
 *  4. Google Sheet (vía Apps Script webhook)
 *
 * Captura UTMs al cargar y los persiste en sessionStorage durante
 * todo el funnel (quiz → PDP → checkout).
 *
 * Asigna un sessionId único + variantId (A/B) por sesión.
 *
 * Uso:
 *   QuizTracker.track('quiz_step_completed', {step: 3, value: 'Labrador'});
 * ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // CONFIGURACIÓN — RELLENA SHEET_URL CUANDO TENGAS APPS SCRIPT
  // ============================================================
  var CONFIG = {
    SHEET_URL: 'https://script.google.com/macros/s/AKfycbwmBT88pmuqQrz9eTOekGWiGwZwjKKE_L3XSyyqOj69cm5gnzK3GPsUMudc7ziyf2gn0g/exec',  // ← Sustituye después de seguir GOOGLE-SHEET-SETUP.md
    DEBUG: false                                    // ← Pon true para ver eventos en consola
  };

  // ============================================================
  // UTILIDADES
  // ============================================================
  function uuid() {
    return 'qz-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 8);
  }

  function safeJSONParse(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getDevice() {
    var w = window.innerWidth;
    if (w < 600)  return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }

  // ============================================================
  // SESSION / VARIANT (A/B)
  // ============================================================
  function getOrCreate(key, factory, storage) {
    storage = storage || sessionStorage;
    var v = storage.getItem(key);
    if (!v) {
      v = factory();
      try { storage.setItem(key, v); } catch (e) {}
    }
    return v;
  }

  var sessionId = getOrCreate('quiz_session_id', uuid);
  var variantId = getOrCreate('quiz_variant_id', function() {
    return Math.random() < 0.5 ? 'A' : 'B';
  }, localStorage);

  // ============================================================
  // UTMS — captura al primer load y persiste
  // ============================================================
  function captureUTMs() {
    var stored = safeJSONParse(sessionStorage.getItem('quiz_utms'), null);
    if (stored) return stored;

    var params = new URLSearchParams(window.location.search);
    var utms = {
      utm_source:   params.get('utm_source')   || '',
      utm_medium:   params.get('utm_medium')   || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content:  params.get('utm_content')  || '',
      utm_term:     params.get('utm_term')     || '',
      fbclid:       params.get('fbclid')       || '',
      gclid:        params.get('gclid')        || '',
      ttclid:       params.get('ttclid')       || '',
      referrer:     document.referrer          || '',
      landing_page: window.location.pathname   || ''
    };

    // Solo guardar si hay algo (no machaca UTMs anteriores cuando se navega internamente)
    var hasAny = Object.keys(utms).some(function(k) { return utms[k]; });
    if (hasAny) {
      try { sessionStorage.setItem('quiz_utms', JSON.stringify(utms)); } catch (e) {}
    }
    return utms;
  }

  var utms = captureUTMs();

  // ============================================================
  // DISPATCH A LOS 4 CANALES
  // ============================================================
  // Mapeo de eventos custom → eventos estándar de Meta.
  // Disparar también un evento estándar simplifica las Custom Conversions:
  // basta con "Event = ViewContent + URL contains pages/cuestionario" sin reglas complejas.
  var STANDARD_EVENT_MAP = {
    'quiz_lp_viewed':         { name: 'ViewContent', props: { content_name: 'Quiz LP' } },
    'quiz_started':           { name: 'InitiateCheckout', props: { content_name: 'Quiz Started' } },
    'quiz_completed':         { name: 'Lead',       props: { content_name: 'Quiz Completed' } },
    'quiz_pdp_redirected':    { name: 'ViewContent', props: { content_name: 'Quiz PDP Personalized' } },
    'quiz_waitlist_shown':    { name: 'ViewContent', props: { content_name: 'Quiz Waitlist Shown' } },
    'quiz_waitlist_submitted':{ name: 'Lead',       props: { content_name: 'Quiz Waitlist Email' } }
  };

  function dispatchPixel(event, props) {
    if (!window.fbq) return;
    try {
      // 1. Evento custom (siempre)
      fbq('trackCustom', event, props);
      // 2. Evento estándar paralelo si el mapping existe (para Meta optimization)
      var std = STANDARD_EVENT_MAP[event];
      if (std) {
        var stdProps = Object.assign({}, std.props || {}, props || {});
        fbq('track', std.name, stdProps);
      }
    } catch (e) {
      if (CONFIG.DEBUG) console.warn('[quiz] Pixel error', e);
    }
  }

  function dispatchGA4(event, props) {
    if (!window.gtag) return;
    try {
      gtag('event', event, props);
    } catch (e) {
      if (CONFIG.DEBUG) console.warn('[quiz] GA4 error', e);
    }
  }

  function dispatchClarity(event, props) {
    if (!window.clarity) return;
    try {
      clarity('event', event);
      // Set custom tags útiles para filtrar replays
      if (props.angulo)  clarity('set', 'quiz_angulo', props.angulo);
      if (props.talla)   clarity('set', 'quiz_talla',  props.talla);
      if (props.step)    clarity('set', 'quiz_last_step', String(props.step));
    } catch (e) {
      if (CONFIG.DEBUG) console.warn('[quiz] Clarity error', e);
    }
  }

  function dispatchSheet(payload) {
    if (!CONFIG.SHEET_URL || CONFIG.SHEET_URL === 'PASTE_YOUR_APPS_SCRIPT_URL_HERE') return;
    try {
      // no-cors → no podemos leer respuesta pero el POST llega
      fetch(CONFIG.SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        keepalive: true  // permite envío durante unload
      }).catch(function() {});
    } catch (e) {
      if (CONFIG.DEBUG) console.warn('[quiz] Sheet error', e);
    }
  }

  // ============================================================
  // STEP TIMER (para medir tiempo en cada paso)
  // ============================================================
  var lastStepEnter = Date.now();
  function resetStepTimer() { lastStepEnter = Date.now(); }
  function elapsedOnStep() { return Math.round((Date.now() - lastStepEnter) / 1000); }

  // ============================================================
  // API PÚBLICA
  // ============================================================
  window.QuizTracker = {
    sessionId: sessionId,
    variantId: variantId,
    utms: utms,
    config: CONFIG,

    track: function(eventName, properties) {
      properties = properties || {};
      var payload = Object.assign({
        timestamp: new Date().toISOString(),
        session_id: sessionId,
        variant_id: variantId,
        event: eventName,
        device: getDevice(),
        viewport_w: window.innerWidth,
        viewport_h: window.innerHeight,
        page: window.location.pathname
      }, utms, properties);

      if (CONFIG.DEBUG) {
        console.log('%c[quiz]', 'color:#F26522;font-weight:bold', eventName, properties);
      }

      dispatchPixel(eventName, properties);
      dispatchGA4(eventName, properties);
      dispatchClarity(eventName, properties);
      dispatchSheet(payload);
    },

    /**
     * Marca el inicio temporal de un paso (para medir tiempo).
     */
    enterStep: function(stepN, stepName) {
      resetStepTimer();
      this.track('quiz_step_viewed', {
        step: stepN,
        step_name: stepName || ''
      });
    },

    /**
     * Llama al pulsar "Siguiente". Calcula automáticamente tiempo en paso.
     */
    completeStep: function(stepN, stepName, value) {
      this.track('quiz_step_completed', {
        step: stepN,
        step_name: stepName || '',
        value: typeof value === 'object' ? JSON.stringify(value) : (value || ''),
        time_on_step: elapsedOnStep()
      });
    }
  };

  // ============================================================
  // EVENTOS DE PÁGINA — auto-dispara LP viewed
  // ============================================================
  if (/\/pages\/(cuestionario|crea-tu-plan|test|quiz)/i.test(window.location.pathname)) {
    QuizTracker.track('quiz_lp_viewed', {
      referrer: document.referrer || ''
    });
  }

  // Detección de abandono (cierra pestaña o cambia de página dentro del quiz)
  var lastEventTime = Date.now();
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      QuizTracker.track('quiz_visibility_hidden', {
        time_visible_seconds: Math.round((Date.now() - lastEventTime) / 1000)
      });
    } else {
      lastEventTime = Date.now();
    }
  });

  // ============================================================
  // SCROLL TRACKING — SOLO en PDP personalizada (no en LP del quiz)
  // ============================================================
  var isOnPDP = /\/products\//i.test(window.location.pathname) &&
                /view=quiz-result/i.test(window.location.search);
  if (isOnPDP) {
    var scrollMilestones = [25, 50, 75, 90];
    var firedMilestones = {};
    window.addEventListener('scroll', function() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.round(window.scrollY / docHeight * 100);
      scrollMilestones.forEach(function(m) {
        if (pct >= m && !firedMilestones[m]) {
          firedMilestones[m] = true;
          QuizTracker.track('quiz_pdp_scroll_' + m, { pct: pct });
        }
      });
    }, { passive: true });
  }

})();
